import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'
import { StyleSheet } from 'react-native'

const MIN_INPUT_FONT_SIZE = 16

export const useCreateStyles = createStyleSheet((theme) => ({
  hiddenInputWeb: {
    ...StyleSheet.absoluteFill,
    // iOS зумит даже прозрачное поле, если его шрифт меньше 16px.
    fontSize: Math.max(rf(MIN_INPUT_FONT_SIZE), MIN_INPUT_FONT_SIZE),
    color: 'transparent',
    backgroundColor: 'transparent',
    textAlign: 'center',
    zIndex: 1,
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: rw(16),
    position: 'relative',
  },
  containerDesktop: {
    gap: rw(16),
  },
  cell: {
    flex: 1,
    flexShrink: 1,
    maxWidth: rw(64),
    height: rh(72),
    borderWidth: rw(1),
    borderRadius: rw(16),
    borderColor: 'transparent',
    backgroundColor: theme.COLOR_BG_SURFACE,
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  cellDesktop: {
    borderColor: 'transparent',
    backgroundColor: theme.COLOR_BG_SURFACE,
  },
  cellFocused: {
    borderColor: 'transparent',
  },
  cellIsError: {
    borderColor: theme.COLOR_STROKE_CRITICAL,
    backgroundColor: theme.COLOR_BG_CRITICAL_SECONDARY,
  },
  cellIsSuccess: {
    borderColor: `${theme.COLOR_STROKE_SUCCESS}20`,
    backgroundColor: theme.COLOR_BG_SUCCESS,
  },
  cellText: {
    fontSize: rf(28),
    fontWeight: '600',
    lineHeight: rf(32.2),
    letterSpacing: rf(-0.56),
  },
  cellTextDesktop: {
    fontSize: rf(28),
  },
  cellTextIsError: {
    color: theme.COLOR_TEXT_CRITICAL,
  },
  cellTextIsSuccess: {
    color: theme.COLOR_TEXT_SUCCESS,
  },
}))
